export default __webpack_public_path__ + "1725ad8a0161cf83d16ee03d62267294.svg";